import React from "react"
import { OTHER } from "../../../../constants"
import CloseIcon from "../../../../../common/components/icons/CloseIcon"
import BackButton from "../BackButton"
import { OptionContainer, Option, OptionLabel } from "../../../tagging/common"
import ThankYou from "../../../ThankYou"

const SpecialistOptions = ({
  showPopUp,
  submitFollowUp,
  specialist,
  handleSpecialistSearch,
  setSpecialist,
  submitted,
  specialistOptions,
}) => {
  return (
    <React.Fragment>
      <CloseIcon onClick={showPopUp(false)} color="#96cdff" />
      <BackButton onClick={submitFollowUp("")} />

      <OptionLabel disable={submitted} color="white" block fontWeight="regular">
        What type of specialist?
      </OptionLabel>

      <OptionContainer>
        {specialistOptions.map(o => (
          <Option
            key={o.token}
            disable={submitted}
            onClick={
              o.token === OTHER
                ? handleSpecialistSearch()
                : setSpecialist({ display: o.text, name: o.token })
            }
            selected={o.token === specialist}
            borderColor="white"
          >
            {o.text}
          </Option>
        ))}
      </OptionContainer>
      {submitted && <ThankYou />}
    </React.Fragment>
  )
}

export default SpecialistOptions



// WEBPACK FOOTER //
// ./assets/feedback/components/postIntent/components/options/SpecialistOptions.js